import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, EventEmitter, input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-select',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './form-select.component.html',
  styleUrl: './form-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSelectComponent implements OnInit {
  readonly label = input<string>('');
  readonly fieldName = input<string>('');
  readonly labelErrorName = input<string>('');
  readonly isRequired = input<boolean>(false);
  readonly isDisabled = input<boolean>(false);
  readonly selectOptions = input<string[]>([]);
  readonly preSelectedOption = input<string>('');

  currentSelected = '';
  emptyOptions = true;

  showError: boolean = true;
  labelError = '';

  touched = false;
  currentValue = '';

  @Output() readonly onDataChanged = new EventEmitter<string>();

  constructor(private readonly cdr: ChangeDetectorRef) {
    effect(() => {
      this.initialSettings();
      this.cdr.markForCheck();
    })
  }

  ngOnInit(): void {
    if (this.fieldName() === 'formName')
    {
      this.labelError = this.labelErrorName() ? this.labelErrorName() : this.label();
      return;
    }
    this.labelError = this.labelErrorName() ? this.labelErrorName() : this.fieldName();
    this.initialSettings();
  }

  private initialSettings(): void {
    const options = this.selectOptions();

    if (this.preSelectedOption()) {
      this.currentSelected = options.find((option) => option === this.preSelectedOption()) ?? '';
    }

    this.emptyOptions = options.length === 0;
    this.showError = this.emptyOptions;
  }

  onSelectChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.currentValue = value;
    this.currentSelected = value;
    this.validateField();

    this.onDataChanged.emit(value);
  }

  onBlur(): void {
    this.touched = true;
    this.validateField();
  }

  private validateField(): void
  {
    this.showError = this.touched && this.isRequired() && this.currentValue.trim() === '';
  }
}
